import Home from "../pages/Home";
import WebsiteManagement from "../pages/WebsiteManagement";
import AccountManagement from "../pages/AccountManagement";

const routers = [
  {
    menu_url: "/home",
    element: <Home> </Home>,
    open_mode: "CURRENT_PAGE",
    menu_name: "智能核查",
    menu_code: "AFC_AUTO_FACT_CHK",
  },
  {
    menu_url: "/websiteManagement",
    element: <WebsiteManagement> </WebsiteManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "核查网站管理",
    menu_code: "AFC_WEBSITE_MGT",
  },
  {
    menu_url: "/accountManagement",
    element: <AccountManagement> </AccountManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "账号管理",
    menu_code: "AFC_WEBSITE_MGT",
  }
];

export default routers;
